import { Stack, styled } from '@mui/material'
import { RoundImage, tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza/text'

type ValueCheckImageWidgetProps = {
    caption?: string
    imageSrc: string
}

const IMAGE_HEIGHT = '370px'

const ImagePreview = styled(RoundImage)(() => ({
    width: '100%',
    height: IMAGE_HEIGHT,
    display: 'block',
}))

export function ValueCheckImageWidget({ caption, imageSrc }: ValueCheckImageWidgetProps) {
    return (
        <Stack direction="column" gap={tokens.SizingSpacing300}>
            {caption && (
                <Typography variant="headline3" color={tokens.ColorTextBoldest}>
                    {caption}
                </Typography>
            )}
            <ImagePreview src={imageSrc} alt={caption || ''} objectFit="contain" height={IMAGE_HEIGHT} width="100%" />
        </Stack>
    )
}
